import React from "react"
import { css } from "@emotion/react"
import { Link } from "react-router-dom"
import { Icon } from "./Icon"

export interface BreadcrumbsEcommProps {
	pages?: {
		name: string
		to?: string
	}[]
}

export const BreadcrumbsEcomm: React.FC<BreadcrumbsEcommProps> = React.memo(({ pages = [] }) => {
	return (
		<nav css={container} aria-label="Breadcrumb">
			{pages.length > 0 && (
				<ul>
					<li>
						<Link to="/" aria-label="Home">
							Home
						</Link>
					</li>
					{pages.map(({ name, to }, i) => (
						<React.Fragment key={name}>
							<li aria-hidden="true">
								<Icon icon="chevron-right" css={separator} aria-hidden="true" />
							</li>
							<li>
								{i === pages.length - 1 ?
									<Link
										to={to ?? "/"}
										aria-current="page"
										css={currentPageStyle}
									>
										{name}
									</Link>
								:	<Link to={to ?? "/"}>{name}</Link>}
							</li>
						</React.Fragment>
					))}
				</ul>
			)}
		</nav>
	)
})

const currentPageStyle = css`
	font-weight: bold;
	display: inline;
`

const container = css`
	margin: 0;

	ul {
		list-style: none;
		padding: 10px 0;
	}

	li {
		display: inline;
	}

	a {
		color: #6b7280;
		font-size: 0.875rem;
		text-decoration: none;
		font-weight: 500;
		cursor: pointer;
	}

	a:focus,
	a:hover {
		color: #0b75e1;
		outline: none;
	}

	a[aria-current="page"] {
		color: #1f2937;
		font-weight: 500;
		cursor: default;
	}
`

const separator = css`
	color: #9ca3af;
	margin: 0 1rem;
`
